import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import data from './goldmedalistsinfo.json';
import './dataviz.scss';
import Tooltip from './Tooltip';
import ImageScroll from './ImagesScroll';

const CareerTrend = () =>  {
    const svgRef = useRef();
    const containerRef = useRef();

    const [tooltipContent, setTooltipContent] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [hovered, setHovered] = useState(null);

    const careerTypes = ['体制内', '体制外'];

    const color = d3.scaleOrdinal()
      .domain(['体制内', '体制外'])
      .range(['#ED6E79', '#658DE5']);

  
      useEffect(() => {
        drawChart();

        const handleResize = () => {
            drawChart();
        }; 
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); 

  const drawChart = () =>  {
    // const margin = { top: 20, right: 30, bottom: 40, left: 60 };
    // const width = 960 - margin.left - margin.right;
    // const height = 300 - margin.top - margin.bottom;

    // const svg = d3.select(svgRef.current)
    //   .attr('width', width + margin.left + margin.right)
    //   .attr('height', height + margin.top + margin.bottom)
    //   .append('g')
    //   .attr('transform', `translate(${margin.left},${margin.top})`);

    const container = d3.select(containerRef.current);
    const svg = d3.select(svgRef.current);
    const containerWidth = container.node().clientWidth;
    const containerHeight = container.node().clientHeight;

  
    const margin = { top: 20, right: 10, bottom: 40, left: 40 };
    const width = containerWidth - margin.left - margin.right;
    const height = containerHeight - margin.top - margin.bottom;

    svg
      .attr('viewBox', `0 0 ${containerWidth} ${containerHeight}`)
      .attr('preserveAspectRatio', 'xMinYMid')
      .attr('width', '100%')
      .attr('height', '100%');

    const svgGroup = svg
      .selectAll('g')
      .data([null])
      .join('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

      const filteredData = data.filter(d => d.careerType !== '不详' && d.careerType !== '现役' && d.retirementYear !== '现役');

      const groupedData = d3.rollup(
          filteredData,
          v => ({
              '体制内': d3.sum(v, d => d.careerType === '体制内' ),
              '体制外': d3.sum(v, d => d.careerType === '体制外' )
          }),
          d => d.retirementYear
          );
  
      const years = d3.range(1984, 2024);
  
      const combinedData = Array.from(groupedData, ([key, value]) => ({
          year: key,
          '体制内': value['体制内'],
          '体制外': value['体制外'],
          'isPlaceholder': false
          }));
      combinedData.sort((a, b) => a.year - b.year);
  
      years.forEach(year => {
        const found = combinedData.find(item => item.year === year);
        if (!found) {
          combinedData.push({ year, '体制内': 0, '体制外': 0, isPlaceholder: year === 1999 });
        }
      });
      combinedData.sort((a, b) => a.year - b.year);
    

    const x = d3.scaleBand()
      // .domain(combinedData.map(d => d.year))
      .domain(years)
      .range([0, width])
      .paddingInner(0.17)
      .paddingOuter(0.1);

    const y = d3.scaleLinear()
      .domain([0, 1])
      .range([height, 0]);

    

    const stack = d3.stack()
      .keys(['体制内', '体制外'])
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetExpand);

    const series = stack(combinedData);

      

    //y
    svgGroup.append('g')
      .attr('class', 'grid')
      .call(d3.axisLeft(y)
        .tickValues([0.25, 0.5, 0.75])
        .tickSize(-width - 10)
        .tickFormat('')
      )
      .call(g => g.select('.domain').remove()); 
      
    svgGroup.append('g')
      .attr('class','y-axis')
      .call(d3.axisLeft(y)
      .tickValues([0.5])
      .tickFormat(d3.format(".0%")))
      .call(g => g.select(".domain").remove());

    svgGroup.append('g')
      .attr('class','mobile-tick')
      .call(d3.axisLeft(y)
      .tickValues([1])
      .tickFormat(d3.format(".0%")))
      .call(g => g.select(".domain").remove())
      .call(g => g.selectAll(".tick text")
      .attr("dy", "-0.7em")
      // .attr("x", 0) // Align the text to the left
      .style("text-anchor", "start"))
      .call(g => g.selectAll(".tick line").remove()
  );

    svgGroup.selectAll('.grid .tick line')
      .attr('class', 'grid-lines')
      .attr('transform', `translate(-5, 0)`); 

    
    //1999
    svgGroup.selectAll('rect').remove(); 

    svgGroup.append('rect')
          .attr('x', x(1999))
          .attr('y', y(1))
          .attr('width', x.bandwidth())
          .attr('height', y(0) - y(1))
          .attr('fill', '#CCCCCC')
          .attr('opacity', 0.5)
          .on('mouseover', (event, d) => {
            setTooltipContent(
              `<div class='tooltip__content'>
              <span class="tooltip__details"><b>1999年</b></span>
              <span class="tooltip__title">
            <span>体制外: 0</span></br>
            <span>体制内: 0</span>
          </span>
              </div>`
            )
            setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 })
            setHovered(event.target);
          })
          .on('mouseout', () => {
            setTooltipContent(null)
            setHovered(null);
          });

    svgGroup.append('g')
      .selectAll('g')
      .data(series)
      .enter().append('g')
      .attr('fill', d => color(d.key))
      .selectAll('rect')
      .data(d => d)
      .enter().append('rect')
      .attr('x', d => x(d.data.year))
      .attr('y', d => y(d[1]))
      .attr('height', d => y(d[0]) - y(d[1]))
      .attr('width', x.bandwidth())
      .on('mouseover', (event, d) => {
        const yearData = combinedData.find(item => item.year === d.data.year);
        setTooltipContent(
          `<div class="tooltip__content">
          <span class="tooltip__details"><b>${d.data.year}年</b></span>
          <span class="tooltip__title">
            <span style="color:#658DE5">体制外: ${yearData['体制外']}</span></br>
            <span style="color:#ED6E79">体制内: ${yearData['体制内']}</span>
          </span>
          </div>`
        );
        setTooltipPosition({ x: event.pageX + 10, y: event.pageY - 28 })
        setHovered(event.target);
      })
      .on('mouseout', () => {
        setTooltipContent(null)
        setHovered(null);
      });

    //x
    svgGroup.append('g')
      .attr('class', 'x-axis')
      .attr('transform', `translate(0,${height})`)
      .call(d3.axisBottom(x)
        .tickValues(x.domain().filter(year => year % 4 === 0))
        .tickSize(0));

  }
  
    return (
      <>
      <div className='content'>
        <div className='content__text'>
          <h3>1987-2000年间，出现短暂的体制外就业高峰</h3>

          <div className='legend'>
          {careerTypes.map((type, i) => (
            <div key={type} className='legend__item'>
              <div className='legend__color' style={{ backgroundColor: color(type) }}></div>
              <div className='legend__label'>{type}</div>
            </div>
          )
        )}
        </div>
        </div>

      </div>
      <div ref={containerRef} className='chart-container' style={{ overflowY:'clip' }}>
        <svg ref={svgRef} id='career-trend'></svg>
        <Tooltip content={tooltipContent} position={tooltipPosition} hovered={hovered} />
      </div>

      <div className='content'>
      <div className='scroll__caption chart-caption'>图注：横轴代表奥运冠军退役的年份，红色和蓝色分别代表当年退役的奥运冠军现于体制内和体制外就业比例。将鼠标悬浮图表，可查看该年份体制内外具体就业人数。</div>
        
        <div className='content__text'>
        <p>上图可见，从1984年至今，在绝大多数年份中，由红色代表的奥运冠军体制内就业数据远超蓝色代表的体制外就业数据。“体制内”就业是大多奥运冠军的选择。值得一提的是，在1987-2000年期间，出现过几个“体制外”就业小高峰，其中主要出路包括经商。有学者认为，这是一段从“强制/包分配”阶段到“市场主导”的过渡期。但也正是在这段时期，奥运冠军在退役后开始出现创业/经商者，例如“第一代体操王子”李宁，在1984年奥运会上共获得3金2银1铜共6块奖牌。1988年退役后，先入职广东健力宝集团，后来创立“李宁”品牌——中国最具影响力的运动品牌之一。 2002年后，中央和地方相应出台退役运动员再就业和再教育政策，奥运冠军“体制外”再就业的比例再未超过“体制内”。</p>

        <p>在中国奥运金牌常客项目中，体操是唯一一个项目，“体制内”就业与“体制外”持平。跳水、羽毛球、排球等项目，也有一些金牌运动员出走体制外。</p>

        </div>

        <ImageScroll
          src1='/images/AP8408040148.jpeg'
          caption1='1984年8月4日晚，中国体操选手李宁（左）和美国选手彼得·维德马尔在洛杉矶奥运会侧马比赛中获得金牌后接受掌声。(AP / Suzanne Vlamis)'
          src2='/images/AP10090209277.jpg'
          caption2='2010年9月2日，中国体育品牌李宁股份有限公司董事长李宁在香港举行的新闻发布会上。(AP / Kin Cheung)'/>

      </div>
      </>
    );
  };

export default CareerTrend;